export default {
  setThemesList(state, payload) {
    state.themes = payload;

    const storedTheme = state.themes.find((theme) => theme.isSelected === true);

    state.currentThemeId = storedTheme.id;
  },

  setPreviewTheme(state, payload) {
    state.previewTheme = payload;
  },

  setEditableThemeId(state, payload) {
    state.editableThemeId = payload;
  },

  setSelectedThemeById(state, themeId) {
    Object.keys(state.themes).forEach((key) => {
      state.themes[key].isSelected = state.themes[key].id === themeId;
    });
  },

  resetSelectedTheme(state) {
    Object.keys(state.themes).forEach((key) => {
      state.themes[key].isSelected = state.themes[key].id === state.currentThemeId;
    });

    state.previewTheme = state.themes.find((theme) => theme.isSelected === true);
  },

  setRelatedForms(state, payload) {
    state.relatedForms = payload;
  },
};
